/**
 * Constantes de colores para estadísticas
 */
export const STATISTICS_COLORS = {
  HOME: '#E63946',
  AWAY: '#9CA3AF',
  BACKGROUND: '#E5E7EB',
};

/**
 * Estadísticas por defecto cuando no hay datos del API
 * Muestra los campos típicos con valores en 0
 */
export const DEFAULT_STATISTICS = [
  { key: 'possession', label: 'POSESIÓN', home: 0, away: 0 },
  { key: 'shots', label: 'REMATES', home: 0, away: 0 },
  { key: 'shots_on_target', label: 'REMATES A PORTERÍA', home: 0, away: 0 },
  { key: 'assists', label: 'ASISTENCIAS', home: 0, away: 0 },
  { key: 'fouls', label: 'FALTAS COMETIDAS', home: 0, away: 0 },
  { key: 'tackles', label: 'FUERAS DE JUEGO', home: 0, away: 0 },
  { key: 'yellow_cards', label: 'TARJETAS AMARILLAS', home: 0, away: 0 },
  { key: 'red_cards', label: 'TARJETAS ROJAS', home: 0, away: 0 },
  { key: 'corners', label: 'CORNERS A FAVOR', home: 0, away: 0 },
  { key: 'crosses', label: 'CENTROS AL ÁREA', home: 0, away: 0 },
];

/**
 * Calcula los porcentajes para una estadística individual
 * @param {number} homeValue - Valor del equipo local
 * @param {number} awayValue - Valor del equipo visitante
 * @param {boolean} isPercentageStat - Si la estadística ya viene en porcentaje (ej: possession)
 * @returns {Object} - { homePercentage, awayPercentage }
 */
export const calculatePercentages = (homeValue, awayValue, isPercentageStat = false) => {
  let homePercentage, awayPercentage;

  if (isPercentageStat) {
    // Estadísticas que ya vienen en porcentaje
    homePercentage = homeValue;
    awayPercentage = awayValue;
  } else {
    // Otras estadísticas: calcular proporción relativa
    const total = homeValue + awayValue;
    homePercentage = total > 0 ? (homeValue / total) * 100 : 0;
    awayPercentage = total > 0 ? (awayValue / total) * 100 : 0;
  }

  return {
    homePercentage: Math.round(homePercentage * 10) / 10,
    awayPercentage: Math.round(awayPercentage * 10) / 10,
  };
};

/**
 * Normaliza las estadísticas transformándolas al formato esperado por la UI
 * Si no hay estadísticas, devuelve un conjunto por defecto con valores en 0
 * @param {Object} statsData - Datos crudos de estadísticas del API
 * @returns {Array} - Array de estadísticas normalizadas
 */
export const normalizeStatistics = (statsData) => {
  // Lista de estadísticas que vienen en porcentaje
  const PERCENTAGE_STATS = ['possession'];

  // Si no hay datos o stats vacío, usar estadísticas por defecto
  const statsToUse = (statsData?.stats && statsData.stats.length > 0) 
    ? statsData.stats 
    : DEFAULT_STATISTICS;

  return statsToUse.map(stat => {
    const homeValue = stat.home || 0;
    const awayValue = stat.away || 0;
    const isPercentageStat = PERCENTAGE_STATS.includes(stat.key);

    const { homePercentage, awayPercentage } = calculatePercentages(
      homeValue,
      awayValue,
      isPercentageStat
    );

    return {
      key: stat.key,
      label: stat.label,
      homeValue,
      awayValue,
      homePercentage,
      awayPercentage,
    };
  });
};